// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__1JQ-L","second":"return_second__2Pbpj","link":"return_link__2WgJQ"};